<script>
	import _ from 'lodash'
	import FilterControlInput from './filter-type-input'

	export default {
		props: {
			scheme: { type: Object, required: true },
			modelValue: { type: Object },
			removeButtonVisible: { type: Boolean, default: true },
			operatorVisible: { type: Boolean, default: false },
			operatorEnabled: { type: Boolean, default: true }
		},
		emits: ['update:modelValue'],
		data() {
			return {
				component: null,
				selectedDataKey: null,
				localValue: null
			}
		},
		computed: {
			schemeProperties() {
				let names = Object.getOwnPropertyNames(this.scheme)
				let arrays = names.reduce((arr, key) => {
					if (key !== '__ob__') {
						arr.push(_.extend({ key }, this.scheme[key]))
					}

					return arr
				}, [])

				return arrays
			},
			componentOptions() {
				return undefined
			},
			componentControl() {
				return this.makeRawComponent(FilterControlInput)
			}
		},
		watch: {
			modelValue: {
				immediate: true,
				deep: true,
				handler(val) {
					if (this.localValue === val) {
						return
					}

					this.localValue = _.extend(this.localValue, val)
					this.defer(() => this.dataKeyChanged(), 10)
				}
			}
		},
		created() { },
		mounted() { },
		methods: {
			getComponent(type) {
				return FilterControlInput
			},
			getInputType(key) {
				let p = _.head(this.schemeProperties.filter(x => x.key === key))
				if (p) {
					return p.type
				} else {
					return 'string'
				}
			},
			dataKeyChanged() {
				let type = this.getInputType(this.localValue.key)
				this.localValue = _.extend({}, this.localValue, { type })
				// this.component = this.getComponent(type)

				this.localValueChanged()
			},
			operatorChanged() {
				this.localValueChanged()
			},
			localValueChanged() {
				this.$emit('update:modelValue', this.localValue)
			},
			emitRemoved() {
				this.$emit('update:modelValue', null, this.localValue)
			}
		}
	}
</script>
<template>
	<div class="row no-gutters mb-3 mb-md-0">
		<div v-if="removeButtonVisible" class="d-none d-md-block col-md-auto ml-md-1">
			<button type="button" class="btn btn-sm btn-danger" @click.stop="emitRemoved">
				<icon icon="trash" />
			</button>
		</div>
		<div v-if="operatorVisible" class="col-12 col-md ml-md-1 operator-col">
			<select v-model="localValue.operator" :disabled="!operatorEnabled ? true : null" class="form-control form-control-sm" @change="operatorChanged">
				<option value="and">و</option>
				<option value="or">یا</option>
			</select>
		</div>
		<div class="col col-md ml-md-1 filter-row-key">
			<select v-model="localValue.key" class="form-control form-control-sm" @change="dataKeyChanged">
				<option v-for="p of schemeProperties" :value="p.key" :key="p.key">{{ p.text }}</option>
			</select>
		</div>
		<div v-if="removeButtonVisible" class="d-block d-md-none col-auto mr-1">
			<button type="button" class="btn btn-sm btn-danger" @click.stop="emitRemoved">
				<icon icon="trash" />
			</button>
		</div>
		<div class="col-12 col-md">
			<component v-if="componentControl" :is="componentControl" :options="componentOptions" v-model="localValue" @update:modelValue="localValueChanged"></component>
		</div>
	</div>
</template>
<style>
	@media (min-width: 768px) {
		.operator-col {
			max-width: 42px;
		}

		.filter-row-key {
			max-width: 150px;
		}
	}
</style>
